import Image from 'next/image';
import { useRouter } from 'next/router';

const ConnectedServices = () => {
  const router = useRouter();

  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/android/i.test(userAgent)) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.toyotaargentina.oneapp';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      window.location.href = 'https://apps.apple.com/br/app/toyota-latam/id1597365457';
    }
    else {
        window.open('https://play.google.com/store/apps/details?id=com.toyotaargentina.oneapp', '_blank');
    }
  };

  const handleSaibaMaisClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    router.push('/servicos-conectados');
  };

  return (
    <div className="w-full max-w-[1920px] mx-auto relative">
      <Image
        src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/home-servicos-conectado/banner_fundo_toyota_servicos_conectado.png"
        alt="Toyota Serviços Conectados"
        width={1920}
        height={1080}
        className="w-full object-cover"
        priority
      />

      <div className="absolute left-[15%] top-[47%] -translate-y-1/2 z-10 w-full max-w-[400px] text-white px-4">
        <div className="flex items-center">
          <svg width="65" height="67" viewBox="0 0 65 67" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 45.6035C10.9523 45.8329 19.7607 54.8155 19.7607 65.8633C19.7607 66.0075 19.7579 66.1514 19.7549 66.2949H0V45.6035ZM0.859375 23.1777C23.635 23.1778 42.0986 41.7096 42.0986 64.5693C42.0986 65.1474 42.0839 65.7226 42.0605 66.2949H33.4619C33.4915 65.7235 33.5068 65.1481 33.5068 64.5693C33.5068 46.4721 18.89 31.8018 0.859375 31.8018C0.572057 31.8018 0.285539 31.8041 0 31.8115V23.1885C0.28575 23.1826 0.572226 23.1777 0.859375 23.1777ZM3.43652 0.757812C37.1255 0.757812 64.4355 29.3272 64.4355 64.5693C64.4355 65.1463 64.4286 65.7216 64.4141 66.2949H56.6895C56.6987 65.8648 56.7041 65.4334 56.7041 65.001C56.7041 33.8069 32.6626 8.51855 3.00684 8.51855C1.99782 8.51856 0.995289 8.54768 0 8.60547V0.858398C1.13749 0.79231 2.28324 0.757817 3.43652 0.757812Z" fill="#EB0A1E"/>
          </svg>
          <div className="h-[90px] border-r border-white ml-4 mr-2"></div>
          <h2 className="text-3xl font-bold leading-tight">
            TOYOTA<br/><span className="text-[#585958]">SERVIÇOS</span><br/><span className="text-[#585958]">CONECTADOS</span>
          </h2>
        </div>
        <p className="mt-4 text-sm leading-relaxed">
          INFORMAÇÕES E DADOS SOBRE O<br/>VEÍCULO DIRETAMENTE NO CELULAR
        </p>
        <p className="text-red-600 font-bold text-xs mt-2">
          CONHEÇA ESSA NOVIDADE.
        </p>
        <div className="flex gap-4 mt-8">
          <a
            href="#"
            onClick={handleDownloadClick}
            className="px-6 py-3 bg-white text-black font-bold rounded-md text-xs no-underline"
          >
            BAIXAR AGORA
          </a>
          <button 
            className="px-6 py-3 border-2 border-white text-white font-bold rounded-md bg-transparent text-xs"
            onClick={handleSaibaMaisClick}
          >
            SAIBA MAIS
          </button>
        </div>
      </div>

      <div className="absolute right-0 top-[-50%] z-10">
        <Image
          src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/home-servicos-conectado/mao-a-direita-servicos-conectado.png"
          alt="Mão direita serviços conectados"
          width={600}
          height={800}
          className="object-contain"
          priority
        />
      </div>

      <div className="absolute bottom-8 right-8 z-10 p-6 flex flex-col md:flex-row items-center gap-6 bg-white bg-opacity-90 rounded-lg">
        <div className="flex-shrink-0">
          <Image
            src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/home-servicos-conectado/QRCode.jpg"
            alt="QR Code"
            width={120}
            height={120}
            objectFit="contain"
          />
        </div>
        <div className="flex flex-col gap-2">
          <Image
            src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/home-servicos-conectado/Google Play.svg"
            alt="Disponível no Google Play"
            width={150}
            height={50}
            objectFit="contain"
          />
          <Image
            src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/home-servicos-conectado/App Store.svg"
            alt="Baixar na App Store"
            width={150}
            height={50}
            objectFit="contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ConnectedServices;
